module.exports = __webpack_public_path__ + "img/thq-cover.fff3dc03.jpg";